import React from "react";
import { useSelector } from "react-redux";
import { selectSoldToShipTo } from "../../../redux/selectors";

const PrintSales = () => {

  const shipToSoldToDetails = useSelector(selectSoldToShipTo);

  const renderDetails = (details, sectionName) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return <p>No details available for {sectionName}</p>;
    }

    return details
      .filter((detail) => detail && Object.keys(detail).length > 0)
      .map((detail, index) => {
        return (
          <div className="section" key={index}>
            <h2 className="text-center">
              <strong>Sales Summary</strong>
            </h2>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td className="col-md-6">
                    <h3> Sold To </h3>
                    <table>
                      <tbody>
                        <tr><td><strong>Customer PO:</strong>{detail.SoldToCustomerPO}</td></tr>
                        <tr><td><strong>Company Name: </strong>{detail.SoldToCompanyName}</td></tr>
                        <tr><td><strong>Address: </strong>{detail.SoldToAddress}</td></tr>
                        <tr><td><strong>Address 2: </strong>{detail.SoldToAddress2}</td></tr>
                        <tr><td><strong>City, State: </strong>{detail.SoldToCity}, {detail.SoldToState}</td></tr>
                        <tr><td><strong>Zip Code: </strong>{detail.SoldToZipCode}</td></tr>
                        <tr><td><strong>Country: </strong>{detail.SoldToCountry}</td></tr>
                        <tr><td><strong>Name: </strong>{detail.SoldToFirstName} {detail.SoldToLastName}</td></tr>
                        <tr><td><strong>Mobile Phone: </strong>{detail.SoldToMobilePhone}</td></tr>
                        <tr><td><strong>Phone: </strong>{detail.SoldToPhone}</td></tr>
                        <tr><td><strong>Fax: </strong>{detail.SoldToFax}</td></tr>
                        <tr><td><strong>Email: </strong>{detail.SoldToEmail}</td></tr>
                      </tbody>
                    </table>
                  </td>
                  <td className="col-md-6">
                    <h3> Ship To </h3>
                    <table>
                      <tbody className="table-print">
                        <tr><td><strong>Company Name: </strong>{detail.ShipToCompanyName}</td></tr>
                        <tr><td><strong>Address: </strong>{detail.ShipToAddress}</td></tr>
                        <tr><td><strong>Address 2: </strong>{detail.ShipToAddress2}</td></tr>
                        <tr><td><strong>City, State: </strong>{detail.ShipToCity}, {detail.ShipToState}</td></tr>
                        <tr><td><strong>Zip Code: </strong>{detail.ShipToZipCode}</td></tr>
                        <tr><td><strong>Country: </strong>{detail.ShipToCountry}</td></tr>
                        <tr><td><strong>Name: </strong>{detail.ShipToFirstName} {detail.ShipToLastName}</td></tr>
                        <tr><td><strong>Mobile Phone: </strong>{detail.ShipToMobilePhone}</td></tr>
                        <tr><td><strong>Phone: </strong>{detail.ShipToPhone}</td></tr>
                        <tr><td><strong>Fax: </strong>{detail.ShipToFax}</td></tr>
                        <tr><td><strong>Email: </strong>{detail.ShipToEmail}</td></tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>Comments:</strong><br />{detail.Comments}
            </p>
            <br className="clearfix" />
            <div className="section">
              <table className="tables">
                <tbody>
                  <tr>
                    <td className="columns">
                      <h3> Shipment Details </h3>
                      <table>
                        <tbody>
                          <tr><td><strong>24h Customer Carrier Call Ahead: </strong>{detail.CustomerCarrierCallAhead}</td></tr>
                          <tr><td><strong>Carrier: </strong>{detail.Carrier}</td></tr>
                          <tr><td><strong>Select Job Site Services Included: </strong>{detail.SelectJobSiteServicesIncluded}</td></tr>
                          <tr><td><strong>Installation Service Type: </strong>{detail.InstallationServiceType}</td></tr>
                          <tr><td><strong>Notification of Shipment: </strong>{detail.NotificationOfShipment}</td></tr>
                          <tr><td><strong>Other: </strong>{detail.ShipmentDetailsOther}</td></tr>
                          <tr><td><strong>Arrival Confirmation Notes: </strong>{detail.ArrivalConfirmationNotes}</td></tr>
                          <tr><td><strong>Station Weight: </strong>{detail.StationWeight}</td></tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      });
  };

  return (
    <div>
      {shipToSoldToDetails ? (
        renderDetails(shipToSoldToDetails, "sales")
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default PrintSales;
